<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Lucide from "@/components/Base/Lucide";
import { useFeesAlertsStore } from "@/stores/feesAlerts";
import { storeToRefs } from "pinia";

const { t } = useI18n();
const router = useRouter();
const store = useFeesAlertsStore();
const { unpaidCount, badgeLabel, hasUnpaid, isFamilyUser } = storeToRefs(store);

const openFees = () => {
  router.push({ name: "family-fees" });
};

onMounted(() => store.startPolling());
onUnmounted(() => store.stopPolling());
</script>

<template>
  <a
    v-if="isFamilyUser && hasUnpaid"
    href=""
    class="relative p-2 rounded-full hover:bg-slate-100 dark:hover:bg-darkmode-400"
    :title="t('fees.header_unpaid', { count: unpaidCount })"
    :aria-label="t('fees.header_unpaid', { count: unpaidCount })"
    @click.prevent="openFees"
  >
    <Lucide icon="Wallet" class="w-[18px] h-[18px]" />
    <span
      class="absolute -top-0.5 -right-0.5 min-w-[1.1rem] h-[1.1rem] px-1 flex items-center justify-center rounded-full bg-warning text-[10px] font-semibold leading-none text-white"
    >
      {{ badgeLabel }}
    </span>
  </a>
</template>
